import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router';
import store from '@/store';
import NotFoundComponent from '@/shared/components/NotFound.vue';
import accountRoutes from '@/account/AccountRoutes';
import adRoutes from '@/ad/AdRoutes';
import estateAgentReviewRoutes from '@/estate-agent-review/EstateAgentReviewRoutes';
import feedbackRoutes from '@/feedback/FeedbackRoutes';
import { urlJoin } from './shared/helpers/urlJoin';
import config from '@/shared/constants/config';

const appRoutes = [
  {
    path: '/404',
    name: '404',
    component: NotFoundComponent,
    meta: {
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: NotFoundComponent,
    meta: {
      showHeader: false,
      showFooter: false,
    },
  },
];

const routes = [...accountRoutes, ...adRoutes, ...estateAgentReviewRoutes, ...feedbackRoutes, ...appRoutes] as any;

let baseUrl: string | undefined = (window as never)['baseUrl'] as string;
const frontRelativeAppUrl: string | undefined = (window as any)['kabernetContext'].frontRelativeAppUrl as string;

baseUrl = urlJoin(frontRelativeAppUrl);

export default function getRouter(isApp: boolean): any {
  const router = createRouter({
    history: isApp ? createWebHistory(baseUrl) : createMemoryHistory(baseUrl),
    routes,
    scrollBehavior(to: any) {
      if (to.hash) {
        return {
          el: to.hash,
        };
      }
      return { top: 0 };
    },
  });

  if (isApp) {
    router.beforeEach(async (to: any, from: any, next: any) => {
      store.commit('menuOpened', false);

      if (to.matched.some((record: any) => record.meta.isDisabled)) {
        next({ name: '404' });
        return;
      } else if (to.matched.some((record: any) => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
          const requiresEstateAgent = to.matched.some((record: any) => record.meta.requiresEstateAgent);

          if (requiresEstateAgent && !store.getters.isEstateAgent) {
            next({ name: '404' });
            return;
          }

          next();
          return;
        }
        next({ name: 'Login', query: { email: to.query.email, returnUrl: encodeURIComponent(to.fullPath) } });
      } else {
        next();
      }
    });
  } else {
    router.beforeEach((to: any) => {
      if (to.fullPath !== '/') {
        window.location.replace(window.location.origin + urlJoin(config.FRONT_RELATIVE_APP_URL, to.fullPath));
      }
    });
  }

  return router;
}
